import { InviteeStatusEnum } from '../../models/jobInviteeStatusEnum';
import { JobStatusEnum } from '../../models/jobStatusEnum';
import { PoolerUser } from '../../models/user';

export function getPoolerBookedTabJobsQuery(_user: PoolerUser): object {
  return {
    $and: [
      {
        status: { $in: [JobStatusEnum.OPEN, JobStatusEnum.CLOSED] },
      },
      {
        invitees: {
          $elemMatch: {
            userId: Meteor.userId(),
            status: { $in: [InviteeStatusEnum.BOOKED] },
          },
        },
      },
    ],
  };
}
